import {
  DefaultPage,
  CustomComponentEditPage,
  CustomDataMappingEditPage,
  CustomFunctionEditPage,
} from './';
import CustomFunctionLogs from './custom-function/CustomFunctionLogs';

export default {
  path: 'custom-component/:version/v',
  name: 'Custom component',
  childRoutes: [
    { path: ':projectId', name: 'Default page', component: DefaultPage, isPrivate: true },
    {
      path: ':projectId/customComponent',
      name: 'Default page',
      component: DefaultPage,
      isPrivate: true,
    },
    {
      path: ':projectId/customComponent/create',
      name: 'Custom Component Edit Page',
      component: CustomComponentEditPage,
      isPrivate: true,
    },
    {
      path: ':projectId/customComponent/edit/:customComponentId',
      name: 'Custom Component Edit Page',
      component: CustomComponentEditPage,
      isPrivate: true,
    },
    {
      path: ':projectId/customDataMapping',
      name: 'Default page',
      component: DefaultPage,
      isPrivate: true,
    },
    {
      path: ':projectId/customDataMapping/create',
      name: 'Custom Data Mapping Edit Page',
      component: CustomDataMappingEditPage,
      isPrivate: true,
    },
    {
      path: ':projectId/customDataMapping/edit/:dataMappingId',
      name: 'Custom Data Mapping Edit Page',
      component: CustomDataMappingEditPage,
      isPrivate: true,
    },
    {
      path: ':projectId/customFunction',
      name: 'Custom function edit page',
      component: DefaultPage,
      isPrivate: true,
    },
    {
      path: ':projectId/customFunction/create',
      name: 'Custom function edit page',
      component: CustomFunctionEditPage,
      isPrivate: true,
    },
    {
      path: ':projectId/customFunction/edit/:customFunctionId',
      name: 'Custom Function Edit Page',
      component: CustomFunctionEditPage,
      isPrivate: true,
    },
    {
      path: ':projectId/customFunction/logs/:customFunctionId',
      name: 'Custom Function Logs Page',
      component: CustomFunctionEditPage,
      isPrivate: true,
    },
  ],
};
